"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputNumber = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _text = require("@oneloop/text");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
require("../../theme/styles/globals.css");
var _excluded = ["disabled", "max", "min", "error", "startVal", "step", "val", "text", "variant"];
/* eslint-disable react/boolean-prop-naming */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var InputNumber = exports.InputNumber = function InputNumber(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 99 : _ref$max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$startVal = _ref.startVal,
    startVal = _ref$startVal === void 0 ? 0 : _ref$startVal,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$val = _ref.val,
    val = _ref$val === void 0 ? function () {} : _ref$val,
    text = _ref.text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(startVal),
    _useState2 = _slicedToArray(_useState, 2),
    valueInput = _useState2[0],
    setValueInput = _useState2[1];
  var _useState3 = (0, _react.useState)([variant]),
    _useState4 = _slicedToArray(_useState3, 2),
    inputVariants = _useState4[0],
    setInputVariants = _useState4[1];
  var inputRef = (0, _react.useRef)();
  var inputCont = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    val(valueInput);
    if (valueInput) {
      setInputVariants([].concat(_toConsumableArray(inputVariants), ['filled']));
    } else {
      setInputVariants(inputVariants.filter(function (elem) {
        return elem !== 'filled';
      }));
    }
  }, [valueInput]);
  (0, _react.useEffect)(function () {
    setValueInput(startVal);
  }, [startVal]);
  (0, _react.useEffect)(function () {
    if (error) {
      setInputVariants([variant, 'focus']);
    }
  }, [error]);
  (0, _react.useEffect)(function () {
    var handleClick = function handleClick(event) {
      var _inputCont$current;
      if (!((_inputCont$current = inputCont.current) !== null && _inputCont$current !== void 0 && _inputCont$current.contains(event.target))) {
        setInputVariants(inputVariants.filter(function (elem) {
          return elem !== 'filled';
        }));
      }
    };
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  var handleChange = function handleChange(e) {
    if (e.target.value === '') {
      return min;
    }
    if (e.target.value >= min && e.target.value <= max) {
      setValueInput(Number(e.target.value));
    } else {
      e.stopPropagation();
    }
  };
  var handleFocus = function handleFocus() {
    if (!disabled) {
      inputRef.current.focus();
      setInputVariants([variant, 'active']);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "div",
    tx: "inputNumber",
    ref: inputCont,
    variant: inputVariants,
    __css: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '7px 10px',
      gap: '8px',
      borderRadius: '8px',
      border: 'solid 1px transparent',
      height: '32px'
    },
    onClick: handleFocus
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    disabled: disabled,
    as: "input",
    ref: inputRef,
    type: "number",
    placeholder: "00",
    id: "inputNumberDisplay",
    value: parseInt(valueInput).toString(),
    onChange: function onChange(e) {
      return handleChange(e);
    },
    __css: {
      width: '22px',
      background: 'transparent',
      border: 'none',
      outline: 'none',
      color: _theme["default"].colors.neutralGray1,
      textAlign: 'center',
      padding: '0'
    }
  }, props, {
    onKeyDown: function onKeyDown(e) {
      if (e.target.value.length === 1 && e.key === 'Backspace') {
        setValueInput(min);
        e.target.value = min;
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "body.fontSize14",
    style: {
      marginRight: '15px'
    }
  }, text), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    id: "arrowUpNumberInput",
    icon: "icon-colapsar",
    fontSize: "12px",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return !disabled && setValueInput(Math.min(max, valueInput + step));
    }
  }), /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    id: "arrowDownNumberInput",
    icon: "icon-dropdown",
    fontSize: "12px",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return !disabled && setValueInput(Math.max(min, valueInput - step));
    }
  })));
};
InputNumber.propTypes = {
  max: _propTypes["default"].number,
  min: _propTypes["default"].number,
  startVal: _propTypes["default"].number,
  step: _propTypes["default"].number,
  val: _propTypes["default"].func,
  text: _propTypes["default"].string,
  variant: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};